module.exports = __webpack_public_path__ + "static/media/find-icon-half.872af0ef.svg";